import { tarabeezaMarkDataUri } from '@/lib/ui-tokens';
import { cn } from '@/lib/utils';
import { useResolvedTheme } from '@/Hooks/useTheme';

interface MarkProps {
  /** Rendered size in px. `tarabeezaMark` drops the tabletop ring below 48. */
  size?: number;
  /** Square off the tile — for a lockup that sits inside another rounded box. */
  radius?: number;
  className?: string;
}

/**
 * The Tarabeeza mark.
 *
 * Drawn once, in `src/lib/ui-tokens/brand.ts`, and consumed here as a data URI rather
 * than inlined markup: the artwork's colours are baked by the `light` flag, so
 * there is nothing for CSS to inherit and nothing gained by putting a dozen
 * <rect>s into this app's DOM.
 *
 * `light` follows the *resolved* theme, not the stored preference — on a cream
 * page the tile is cream and the table is dark; on the brand's black the tile
 * is the brown of the lockup. Handing it the wrong one is how a logo ends up
 * as a bright card floating on a dark page.
 */
export function Mark({ size = 28, radius, className }: MarkProps) {
  const theme = useResolvedTheme();

  return (
    <img
      src={tarabeezaMarkDataUri({ size, light: theme === 'light', radius })}
      width={size}
      height={size}
      alt="Tarabeeza"
      className={cn('shrink-0 select-none', className)}
      draggable={false}
    />
  );
}
